// extracted by mini-css-extract-plugin
export default {"label":"ActivationPublicPage_label__aL2Og","avatarBlock":"ActivationPublicPage_avatarBlock__bc9dZ","inputsBlock":"ActivationPublicPage_inputsBlock__VBVMm"};